import { render, staticRenderFns } from "./OptimizeModal.vue?vue&type=template&id=1c5697c6&scoped=true"
import script from "./OptimizeModal.vue?vue&type=script&lang=ts"
export * from "./OptimizeModal.vue?vue&type=script&lang=ts"
import style0 from "./OptimizeModal.vue?vue&type=style&index=0&id=1c5697c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5697c6",
  null
  
)

export default component.exports